import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from '../lib/firestore.service';
// import { UserAccountMapsService } from '../lib/userAccountMaps.service';
import type { TUser, TRole /* , TFirestoreObject */ } from '@shared/models';
// TODO: Implement TFirestoreObject
@Injectable({
    'providedIn': 'root'
})
export class UsersService {
    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    public getNullable(): TUser {
        const user: TUser = {
            'firstName': '',
            'lastName': '',
            'cellPhone': '',
            'email': '',
            'role': 'serviceAdvisor',
            'roleTitle': 'Service Advisor',
            'uid': ''
        };
        return user;
    }

    public getObservable(): Observable<TUser[]> {
        const path = this.firestorePathsService.getUsersPath();
        const observable = this.firestoreService.getObservable(path) as Observable<TUser[]>;
        return observable;
    }

    public async getByUid(uid: string): Promise<TUser> {
        const path = this.firestorePathsService.getUsersPath();
        return this.firestoreService.getByUid(path, uid) as Promise<TUser>;
    }

    public async getByEmail(email: string): Promise<TUser | null> {
        const users = await this.getByFieldValue('email', email);
        return users.length > 0 ? users[0] : null;   // return users[0];
    }

    public async getByCellPhone(cellPhone: string): Promise<TUser | null> {
        const users = await this.getByFieldValue('cellPhone', cellPhone);
        return users.length > 0 ? users[0] : null;
    }

    public async getByFieldValue(fieldName: string, fieldValue: any): Promise<TUser[]> {
        const collection = this.firestorePathsService.getUsersPath();
        return this.firestoreService.getByFieldValue(collection, fieldName, fieldValue) as Promise<TUser[]>;
    }

    public async getAll(): Promise<TUser[]> {
        const path = this.firestorePathsService.getUsersPath();
        return this.firestoreService.getAll(path) as Promise<TUser[]>;
    }

    public async add(user: TUser): Promise<TUser> {
        user.email = user.email.toLowerCase();
        const path = this.firestorePathsService.getUsersPath();
        return this.firestoreService.add(path, user) as Promise<TUser>;
        // return this.firestoreService.add(collection, user as unknown as TFirestoreObject);
    }

    public async set(user: TUser, uid: string): Promise<TUser> {
        user.uid = uid;
        user.email = user.email.toLowerCase();
        const collection = this.firestorePathsService.getUsersPath();
        return this.firestoreService.set(collection, user) as Promise<TUser>;
    }

    public async update(user: TUser): Promise<TUser> {
        user.email = user.email.toLowerCase();
        const path = this.firestorePathsService.getUsersPath();
        return this.firestoreService.update(path, user) as Promise<TUser>;
    }

    public async delete(uid: string): Promise<void> {
        const path = this.firestorePathsService.getUsersPath();
        return this.firestoreService.delete(path, uid);
    }

    public async getUsersByAccountNumber(accountNumber: string): Promise<TUser[]> {
        const path = this.firestorePathsService.getUsersColByAccountNumber(accountNumber);
        return this.firestoreService.getAll(path) as Promise<TUser[]>;
    }

    public async getUsersByRole(role: TRole): Promise<TUser[]> {
        const allUsers = await this.getAll();
        const users = allUsers.filter((u) => (u.role === role));
        const sortedUsers = this.sort(users);
        return sortedUsers;
    }

    public sort(users: TUser[] /* , sortAscending = true */): TUser[] {
        const sortedUsers = users.sort((a, b) => {
            const aFullname = a.firstName + ' ' + a.lastName;
            const bFullname = b.firstName + ' ' + b.lastName;
            if (aFullname < bFullname) {
                return -1;
            } else if (aFullname > bFullname) {
                return 1;
            } else {
                return 0;
            }
        });
        return sortedUsers;
        // });

        // const aOrderId = a?.header?.orderId;
        // const bOrderId = b?.header?.orderId;

        // if (!aOrderId || !bOrderId) {
        //     return;
        // }

        // // This is a reverse sort
        // if (aOrderId < bOrderId) {
        //     // return -1;
        //     return (sortAscending ? -1 : 1);
        // } else if (aOrderId > bOrderId) {
        //     // return 1;
        //     return (sortAscending ? 1 : -1);
        // } else {
        //     return 0;
        // }
        // });
        // return sortedOrders;
    }

    // A successful delete requires that the user be deleted from:
    // 1) UserAccountMap - to disassociate the user from the dealership.
    // 2) Users - to disassociate the user from the dealership
    // 3) Auth - to prevent further logins
    // public deleteUser(user: TUser): Promise<{}> {
    //     const uid = user.uid;
    //     const email = user.email;
    //     const password = user.password;

    //     const promise = new Promise((resolve, reject) => {
    //         this.userAccountMapsService.delete(user.uid)
    //         .then((result) => {
    //             return this.delete(user.uid);
    //         })
    //         .then((result) => {
    //             // return AuthService.deleteUser(email, password);
    //             // The only user Firebase allows you to delete is the logged in user.
    //             // So schedule this user to be deleted by creating an action.
    //             // The DeleteUserAction will have to be done by hand.
    //             console.error('Avoid having the backend call a firebase function');
    //             console.error('Create a Firestore webhook api that will delete the user.');
    //             return Promise.resolve();
    //             // return this.firebaseFunctionsService.deleteUser(uid, email);
    //         })
    //         .then(() => {
    //             resolve(true);
    //         })
    //         .catch((err) => {
    //             reject(err);
    //         });
    //     });
    //     return promise;
    // }
}

// private createObservable() {
//     this.myObservable = new Observable((observer) => {

//         const users = [];
//         const collection = this.firestorePathsService.getUsersPath();
//         const ref = collection.ref;
//         ref.onSnapshot((snapshot) => {
//             snapshot.forEach((doc) => {
//                 const item = doc.data();
//                 users.push(item);
//             });
//         });

//         observer.next(users);
//     });
// }

// private createObservable2() {
//     this.myObservable = new Observable((observer) => {

//         const users = [];
//         const collection = this.firestorePathsService.getUsersPath();
//         // const ref = collection.ref;
//         collection.snapshotChanges().forEach((docs) => {
//             // const item = doc.data();
//             docs.forEach((doc) => {
//                 const data = doc.payload.doc.data() as TUser;
//                 // const id = doc.payload.doc.id;
//                 // data.uid = id;
//                 users.push(data);
//             });

//         // })       // ref.onSnapshot((snapshot) => {
//         //     snapshot.forEach((doc) => {
//         //         const item = doc.data();
//         //         users.push(item);
//         //     });
//         });

//         observer.next(users);
//     });
// }

